import { useEffect } from 'react';
/**
 * Hook to check if the click is outside of the refs
 *
 * @param refs - Refs to the elements to check if the click is outside of
 * @param callback - Callback to be called when the click is outside of the refs
 * @returns void
 */
const useClickOutside = ({ refs, callback }) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            const areRefsValid = refs.every((ref) => ref.current !== null);
            if (!areRefsValid)
                return;
            const isClickOutside = refs.every((ref) => !ref.current?.contains(event.target));
            if (isClickOutside) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [refs, callback]);
};
export default useClickOutside;
